import { render, staticRenderFns } from "./BlockExerciseCard.vue?vue&type=template&id=4ab2eda1&scoped=true"
import script from "./BlockExerciseCard.vue?vue&type=script&lang=js"
export * from "./BlockExerciseCard.vue?vue&type=script&lang=js"
import style0 from "./BlockExerciseCard.vue?vue&type=style&index=0&id=4ab2eda1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab2eda1",
  null
  
)

export default component.exports